import Vue from "vue";
import Component from "vue-class-component";

const ScrollLockProps = Vue.extend({});

@Component({
  name: "ScrollBlock",
})

export default class ScrollBlock extends ScrollLockProps {
  lock(): void {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
  }

  unlock(): void {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
  }
}
